import { ComingSoon } from './ComingSoon';
import { IconAgent, IconAnalytics, IconCode, IconIntegrations, IconKnowledge } from '../ui/Icon';

export function CodeViewerStub() {
  return (
    <ComingSoon
      title="Código"
      subtitle="Navegar pelo repositório direto do dashboard"
      icon={<IconCode size={28} />}
      pitch="Em breve: visualizar o código do projeto sem sair do Neo-Pilots"
      bullets={[
        'Tree de arquivos + viewer com syntax highlight',
        'Trocar entre branches e ver diffs entre elas',
        'Botão "abrir no Claude" pra mandar arquivo+linha pro chat',
        'Read-only: edits sempre via PR',
      ]}
    />
  );
}

export function AgentsStub() {
  return (
    <ComingSoon
      title="Agentes"
      subtitle="Múltiplos especialistas Claude com papéis definidos"
      icon={<IconAgent size={28} />}
      pitch="Em breve: configurar e orquestrar agentes especializados"
      bullets={[
        'Reviewer, Tester, Domain Expert, Architect, Security, Doc Writer',
        'Cada um com prompt e tools próprios',
        'Invocação manual ou automática (ex: reviewer roda quando CI passa)',
        'Histórico de runs com custo e duração por agente',
      ]}
    />
  );
}

export function IntegrationsStub() {
  return (
    <ComingSoon
      title="Integrações"
      subtitle="Neo-Pilots como hub de bugs, eventos e notificações"
      icon={<IconIntegrations size={28} />}
      pitch="Em breve: integrações inbound e outbound plugáveis"
      bullets={[
        'Inbound: Sentry, Crashlytics, Steam reviews, Play Store, Discord, email',
        'Outbound: Slack, Discord, Linear/Jira',
        'Webhook genérico pra qualquer fonte',
        'Mapeamento automático de stack trace → área do código',
      ]}
    />
  );
}

export function KnowledgeStub() {
  return (
    <ComingSoon
      title="Base do projeto"
      subtitle="Premises, glossário, ADRs e runbooks num só lugar"
      icon={<IconKnowledge size={28} />}
      pitch="Em breve: knowledge base estruturada que os agentes consultam"
      bullets={[
        'Editor markdown com preview lado a lado',
        'Glossário versionado (commit no repo)',
        'ADRs (decisões arquiteturais) e runbooks',
        'Cada agente lê a fatia da KB que importa pra ele',
      ]}
    />
  );
}

export function AnalyticsStub() {
  return (
    <ComingSoon
      title="Analytics"
      subtitle="Saúde do sistema, throughput e custo dos agentes"
      icon={<IconAnalytics size={28} />}
      pitch="Em breve: telemetria e métricas operacionais"
      bullets={[
        'Throughput de reports por kind/projeto',
        'Lead time (report → resolved)',
        'Taxa de sucesso de auto-fix por projeto',
        'Custo de IA (tokens × $) por agente / mês',
        'Heatmap das áreas mais reportadas',
      ]}
    />
  );
}
